import { useAdminUpdate } from '@reapitform/hooks'
import { AdminRecipientCard, AdminRecipientCardPayload } from '../types'

/** Updates a recipient card (`PUT /recipient-steps/{stepRef}/cards/{cardRef}`). */
export const useUpdateAdminRecipientCard = (recipientStepReferenceID: string, recipientCardReferenceID: string) =>
  useAdminUpdate<AdminRecipientCardPayload, AdminRecipientCard>({
    path: `/api/recipient-steps/${recipientStepReferenceID}/cards/${recipientCardReferenceID}`,
    method: 'PUT',
    errorMessage: 'Failed to update the recipient card',
    successMessage: 'Recipient card updated',
  })
